// extracted by mini-css-extract-plugin
export default {"criteriaLabelContainer":"oTydvyINmfEuJPAvUXYW","switcher":"yFQxPVs8yLksCJBivfoH"};